<template>
  <div class="box">
    <!-- 顶部导航 start -->
    <nav-bar />
    <!-- banner start -->
    <div style="overflow: hidden">
      <banner
        :bannerSrc="require('../../assets/images/banner_5.png')"
        isnum="about"
      />
    </div>

    <!-- 内容 -->
    <details-cat />
    <!-- 页脚 start -->
    <footers />
  </div>
</template>
<script>
import NavBar from "@/components/NavBar";
import Banner from "@/components/Banner";
import Footers from "@/components/Footer";
import DetailsCat from "./component/DetailsCat";
import { newsDetail } from "@/api/index";

export default {
  name: "Details",
  components: {
    NavBar,
    Banner,
    Footers,
    DetailsCat,
  },
  data() {
    return {
      obj: {},
    };
  },
  created() {
    //滚动条滚到顶部
    this.$BackTop();
    //新闻详情
  },
  mounted() {

  },
  destroyed(){
    location.reload()
  },
  methods: {
    funcDetail(id) {
      //最新资讯详情
      var params = {
        id: id,
      };
      newsDetail(params)
        .then((response) => {
          this.obj = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  width: 100%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/Details/index.vue